import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/mirandaalliance.png")